
import React, { useEffect, useState, useRef } from "react";
import { setSecureUser } from "../utils/secureStorage";
import Inputs from "../components/Inputs";
import Button from "../components/Buttons/Button";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import { Alert } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import DOMPurify from "dompurify";
import { Link } from "react-router-dom";
import { sendOtp } from "../utils/sendOtp";

export default function Signup() {
  const [emptyFieldAlert, setEmptyFieldAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [emailAlert, setEmailAlert] = useState(false);
  const [existingUserAlert, setExistingUserAlert] = useState(false);
  const [captchaAlert, setCaptchaAlert] = useState(false);
  const [input, setInput] = useState({
    fname: "",
    lname: "",
    mname: "",
    phone: "",
    email: "",
    password: "",
    dob: "",
    cpassword: "",
  });
  const [gender, setGender] = useState();
  const [org, setOrg] = useState();
  const [orgView, setOrgView] = useState([]);
  const dobRef = useRef(null);
  const recaptcha = useRef();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [passwordMatched, setPasswordMatched] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const submitButtonRef = useRef(null);

  useEffect(() => {
    const urlView = `${process.env.REACT_APP_API}/viewweb/organizationfilter?type=&category=`;

    axios
      .get(urlView, { withCredentials: true })
      .then((res) => {
        setOrgView(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  function handleInputs(e) {
    const { name, value } = e.target;
    const sanitizedValue = DOMPurify.sanitize(value);
    setInput((prevInput) => ({
      ...prevInput,
      [name]: sanitizedValue,
    }));

    if (name === "email") {
      if (!validateEmail(sanitizedValue)) {
        setEmailError("Invalid email format");
      } else {
        setEmailError("");
      }
    }

    if (name === "cpassword") {
      if (sanitizedValue !== input.password) {
        setError("Passwords do not match");
        setPasswordMatched(false);
      } else {
        setError("");
        setPasswordMatched(true);
      }
    } else {
      setError("");
      setPasswordMatched(false);
    }

    if (name === "password") {
      if (!validatePassword(sanitizedValue)) {
        setPasswordError("Invalid password format.");
      } else {
        setPasswordError("");
      }
    }
  }

  const handlePhoneInput = (e) => {
    const { value } = e.target;
    const onlyDigits = value
      .split("")
      .filter((char) => /^\d+$/.test(char))
      .join("");
    setInput((prevInput) => ({
      ...prevInput,
      phone: onlyDigits,
    }));
  };

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  function validatePassword(password) {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  }

  const handleFormSubmission = async () => {
    if (input.password !== input.cpassword) {
      setEmailAlert(true);
      setTimeout(() => {
        setEmailAlert(false);
      }, 5000);
      return;
    }

    if (
      input.fname &&
      input.lname &&
      input.dob &&
      gender &&
      org && 
      input.phone &&
      validateEmail(input.email) &&
      validatePassword(input.password) &&
      input.password === input.cpassword &&
      emailError === "" &&
      passwordError === ""
    ) {
      try {
        const captchaValue = recaptcha.current.getValue();
        if (!captchaValue) {
          alert("Please verify the reCAPTCHA!");
          return;
        }
        const url = `${process.env.REACT_APP_API}/secure/signup`;

        const data = {
          fname: DOMPurify.sanitize(input.fname, {
            ALLOWED_ATTR: [],
            ALLOWED_TAGS: [],
          }),
          mname: DOMPurify.sanitize(input.mname, {
            ALLOWED_ATTR: [],
            ALLOWED_TAGS: [],
          }),
          lname: DOMPurify.sanitize(input.lname, {
            ALLOWED_ATTR: [],
            ALLOWED_TAGS: [],
          }),
          dob: DOMPurify.sanitize(input.dob, {
            ALLOWED_ATTR: [],
            ALLOWED_TAGS: [],
          }),
          phone: DOMPurify.sanitize(input.phone, {
            ALLOWED_ATTR: [],
            ALLOWED_TAGS: [],
          }),
          gender: DOMPurify.sanitize(gender, {
            ALLOWED_ATTR: [],
            ALLOWED_TAGS: [],
          }),
          email: DOMPurify.sanitize(input.email, {
            ALLOWED_ATTR: [],
            ALLOWED_TAGS: [],
          }),
          password: DOMPurify.sanitize(input.password, {
            ALLOWED_ATTR: [],
            ALLOWED_TAGS: [],
          }),
          organization: DOMPurify.sanitize(org, {
            ALLOWED_ATTR: [],
            ALLOWED_TAGS: [],
          }),
          recaptcha: captchaValue,
        };

        axios
          .post(url, data, { withCredentials: true })
          .then(async(res) => {
            if (res.status === 201) {
              setSecureUser(input);
              await sendOtp(input)
              setSuccessAlert(true);
              setTimeout(() => {
                setSuccessAlert(false);
                window.location.hash = "/verification";
              }, 2000);
            }
          })
          .catch((error) => {
            const { status, data } = error.response;
            if (status === 409 && data.message === "User already exists") {
              setExistingUserAlert(true);
              setTimeout(() => {
                setExistingUserAlert(false);
              }, 2000);
            } else if (status === 400 && data.message === "Invalid Captcha.") {
              setCaptchaAlert(true);
              setTimeout(() => {
                setCaptchaAlert(false);
              }, 2000);
            } else {
              setErrorAlert(true);
              setTimeout(() => {
                setErrorAlert(false);
              }, 2000);
            }
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      setEmptyFieldAlert(true);
      setTimeout(() => {
        setEmptyFieldAlert(false);
      }, 5000);
    }
  };

  return (
      <div className="flex justify-center py-20 ">
        <div className="department-creation-wrapper rounded-md mx-auto my-auto md:w-1/2 lg:w-1/3 xl:w-1/4">
          <h3 className="text-center mb-6">Sign Up</h3>
          <div className="flex flex-wrap mb-2">
            <div className="w-full md:w-1/3 px-2 mb-4 md:mb-0">
              <div className="relative">
                <Inputs
                  type="text"
                  placeholder="First Name"
                  name="fname"
                  required={true}
                  value={input.fname}
                  fun={handleInputs}
                />
                {!input.fname && (
                  <span className="absolute top-1 right-1 text-red-500 text-xl">
                    *
                  </span>
                )}
              </div>
            </div>
            <div className="w-full md:w-1/3 px-2 mb-4 md:mb-0">
              <Inputs
                type={"text"}
                placeholder={"Middle Name"}
                name={"mname"}
                fun={handleInputs}
              />
            </div>
            <div className="w-full md:w-1/3 px-2">
              <div className="relative">
                <Inputs
                  type={"text"}
                  placeholder={"Last name"}
                  name={"lname"}
                  required={true}
                  value={input.lname}
                  fun={handleInputs}
                />
                {!input.lname && (
                  <span className="absolute top-1 right-1 text-red-500 text-xl">
                    *
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-wrap mb-2">
            <div className="w-full md:w-1/2 px-2 mb-4 md:mb-0">
              <div className="relative">
                <Inputs
                  type="date"
                  name="dob"
                  required={true}
                  value={input.dob}
                  fun={handleInputs}
                  ref={dobRef}
                />
                {!input.dob && (
                  <span className="absolute top-0 right-1 text-red-500 text-xl">
                    *
                  </span>
                )}
              </div>
            </div>
            <div className="w-full md:w-1/2 px-2">
              <div className="relative">
                <select
                  className="w-full border rounded px-3 py-2"
                  onChange={(e) => setGender(e.target.value)}
                >
                  <option>Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
                {!gender && (
                  <span className="absolute top-0 right-1 text-red-500 text-xl">
                    *
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-wrap mb-4">
            <div className="w-full md:w-1/2 px-2 mb-4 md:mb-0">
              <div className="relative select-wrapper">
                <select
                  className="w-full border rounded px-3 py-2"
                  onChange={(e) => setOrg(e.target.value)}
                >
                  <option>Select Organization</option>
                  {orgView.map((data, index) => {
                    return (
                      <option
                        value={DOMPurify.sanitize(data.organization)}
                        key={index}
                      >
                        {DOMPurify.sanitize(data.organization)}
                      </option>
                    );
                  })}
                </select>
                {!org && (
                  <span className="absolute top-0 right-1 text-red-500 text-xl">
                    *
                  </span>
                )}
              </div>
            </div>
            <div className="w-full md:w-1/2 px-2">
              <div className="relative">
                <Inputs
                  type="tel"
                  placeholder={"Enter Phone"}
                  pattern={"[0-9]*"}
                  name={"phone"}
                  fun={handlePhoneInput}
                />
                {!input.phone && (
                  <span className="absolute top-0 right-1 text-red-500 text-xl">
                    *
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="w-full px-2 mb-2">
            <div className="relative">
              <Inputs
                type={"email"}
                placeholder={"Enter email"}
                name={"email"}
                fun={handleInputs}
              />
              {!input.email && (
                <span className="absolute top-0 right-1 text-red-500 text-xl">
                  *
                </span>
              )}
            </div>
            {emailError && <p className="text-red-500">{emailError}</p>}
          </div>
          <div className="w-full px-2 mb-2">
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="flex flex-col">
                <div className="w-full md:full px-2 mb-4 md:mb-2 relative">
                  <Inputs
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter Password"
                    name="password"
                    fun={handleInputs}
                  />
                  <span
                    className="absolute right-3 top-3 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>

                <div className="w-full md:w-full px-2 mb-4 md:mb-2 relative">
                  <Inputs
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    name="cpassword"
                    fun={handleInputs}
                  />
                  <span
                    className="absolute right-3 top-3 cursor-pointer"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                  {error && <p className="text-red-500">{error}</p>}
                  {passwordMatched && (
                    <p className="text-green-500">Passwords matched!</p>
                  )}
                  {passwordError && (
                    <p className="text-red-500">{passwordError}</p>
                  )}
                </div>
              </div>

              <p className="text-sm">
                Password must be at least 8 characters, contain at least one
                numeric value, one special character, have at least one
                uppercase and one lowercase.
              </p>
              <div></div>
            </div>
          </div>
          <div style={{ textAlign: "left" }}>
            <p className="italic">
              NOTE: Fields with{" "}
              <span
                className="text-red-500 text-xl"
                style={{ verticalAlign: "middle" }}
              >
                *
              </span>{" "}
              are mandatory
            </p>
          </div>
          <ReCAPTCHA
            ref={recaptcha}
            sitekey={process.env.REACT_APP_SITE_KEY_V2}
            className="mb-5"
          />
          <Button
            id="submit-button"
            ref={submitButtonRef}
            value={"Submit"}
            className="w-3/4"
            fun={handleFormSubmission}
            disabled={
              !passwordMatched || emailError !== "" || passwordError !== ""
            }
          />
          <div className="text-left p-2 text-blue-500"><Link to="/login">Already have an account? Login here.</Link></div>
          {successAlert && (
            <Alert severity="success" style={{ marginTop: "20px" }}>
              Registered Successfully
            </Alert>
          )}
          {emptyFieldAlert && (
            <Alert severity="error" style={{ marginTop: "20px" }}>
              All fields required
            </Alert>
          )}
          {errorAlert && (
            <Alert severity="error" style={{ marginTop: "20px" }}>
              Something went wrong
            </Alert>
          )}
          {emailAlert && (
            <Alert severity="error" style={{ marginTop: "20px" }}>
              Password and Confirm Password are not same
            </Alert>
          )}
          {existingUserAlert && (
            <Alert severity="error" style={{ marginTop: "20px" }}>
              User already exists
            </Alert>
          )}
          {captchaAlert && (
            <Alert severity="error" style={{ marginTop: "20px" }}>
              Invalid Captcha
            </Alert>
          )}
        </div>
      </div>
  );
}
